// A section payload carries its bobbin answer (BobbinGating#to_hash, serialized by both Manufacturing Cost
// Calculator front doors): whether the bobbin row is drawn, whether the customer may change it, and how it
// starts. The rows RENDER that answer and never derive it, so a payload that arrives without one draws no
// bobbin row at all -- the customer silently loses the ability to produce on a bobbin, on a page that
// otherwise looks fine.
//
// This says so loudly instead. A payload that carries a part_type but no bobbin answer is a broken server
// contract (a front door that forgot to serialize it), not a state the customer can reach.
//
// A command, not a query: it reports, it never decides. Reading the answer stays a plain `payload.bobbin` at
// the two rows, so this file can never grow into a second implementation of the rule.
export const reportMissingBobbinAnswer = (payload) => {
  if (!payload || payload.bobbin != undefined) { return; }
  // No part_type yet means the section is still resolving -- there is nothing to answer about, so nothing
  // to report.
  if (payload.part_type == undefined) { return; }

  console.error(
    `Section material sheets for part_type "${payload.part_type}" carry no bobbin answer, ` +
    'so the bobbin row cannot be drawn. The endpoint must serialize BobbinGating#to_hash.'
  );
};

export default reportMissingBobbinAnswer;
